//
//
//
//
//
//

import FeedbackForm from '@/utils/FeedbackForm'

// ff-rating-button
export default {
    props: {
        form: { type: FeedbackForm, required: true },
        formEl: { type: Object, required: true },
    },
    computed: {
        buttonDesign: function() {
            if (this.formEl.options && this.formEl.options.design === 'link') {
                return 'button button-link'
            } else if (this.formEl.options && this.formEl.options.design === 'card') {
                return 'button-card'
            } else {
                return 'button button-blue button-rounded button-md submit'
            }
        },
        disabled: function() {
            if (this.formEl && this.formEl.options && this.formEl.options.requires) {
                const answers = this.form.feedbackAnswersObject.form_elements

                if (this.formEl.options.requires.length > 0) {
                    let disabled = true
                    for (const requireId of this.formEl.options.requires) {
                        for (const answer of answers) {
                            if (answer.id == requireId) {
                                disabled = disabled && !answer.answer
                            }
                        }
                    }

                    return disabled
                }
            }

            return false
        },
    },
    methods: {
        onClick() {
            if (this.formEl.options.href) {
                this.handleCustomAction()
            }

            this.$emit('click', true)
        },
        handleCustomAction() {
            switch (this.formEl.options.href) {
                case 'relationship_contact':
                    this.$emit('contact')
                    break
                case 'relationship_see_profile':
                    this.$emit('see-profile')
                    break
                case 'relationship_ping_admin':
                    this.$emit('ping-admin')
                    break
                default:
                    return null
            }
        },
    },
}
